import React, { Component } from 'react'
import './Stores.css'
import { connect } from 'react-redux'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import AuthenticationService from '../Security/AuthenticationService'
import { Config } from '../../Config'
import Unregistersystem from '../Actions/Unregistersystem'
import NavigationService from '../Common/NavigationServices'
import CommonFunctions from '../../components/Common/Functions'
import CommonStoreMethods from './CommonStoreMethod'
const offlineImage = require('../../images/connection_offline.png')
const OnlineImage = require('../../images/connection_online.png')

class ZoomComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      disableRemove: true,
      deviceIDs: [],
      deviceName: 'Zoom'
    }
    this.navigate = new NavigationService()
    this.commonFunctions = new CommonFunctions()
    this.CommonStoreMethods = new CommonStoreMethods()
    this.enableRemoveBtn = this.enableRemoveBtn.bind(this)
    this.handleViewDevice = this.handleViewDevice.bind(this)
    this.checkRemotePermission = this.checkRemotePermission.bind(this)
    this.renderRows = this.renderRows.bind(this)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    this.state.token = this.authService.getToken()
  }
  handleViewDevice (id) {
    this.props.viewDevice(id)
  }
  renderHTTP (url) {
    return url.replace('https', 'http')
  }
  checkRemotePermission (data) {
    return (
      <td>
        <img src={OnlineImage} className={'cstat ' + (data.Device_IsActive ? '' : 'hidden')} alt='Device Online' />
        <img src={offlineImage} className={'cstat ' + (!data.Device_IsActive ? '' : 'hidden')} alt='Device Offline' />
        <span style={{ 'padding': '0 5px' }}>
          {/* Calling the remote connect permission check function. */}
          {this.renderStatus(data)}
        </span>
      </td>
    )
  }
  // Checks for the enabling the remove system button.
  enableRemoveBtn (e, deviceId, active) {
    let disableRemove = this.commonFunctions.enableRemoveBtn(e, deviceId, active)
    this.setState({ disableRemove: disableRemove })
  }

  // Checking the device status and remote connect permission.
  renderStatus (device) {
    return this.CommonStoreMethods.renderStatus(device, this.props.isRemoteConnection) // renderStatus(device, this.props.isRemoteConnection)
  }
  renderRows () {
    const { language } = this.state
    let row = this.props.stores.Device_Details
    let event = this
    row = row.filter(function (el) {
      return el.Device_Name !== 'CIB' && el.Device_Name !== 'ION' && el.Device_Name !== 'EOS'
    })
    let rows = row.map((data) => {
      return (
        <tr className='device-row-data'>
          <td className='device-checkbox'>
            <input type='checkbox' name='checkbox' id='idname' className={'device-check-input ' + (this.authService.isAdmin() ? 'show' : 'hide')}
              value={data.Device_UID} onChange={e => this.enableRemoveBtn(e, data.Device_UID, data.Device_IsActive)} />
          </td>
          <td >{data.Device_MainVersion}</td>
          <td >{data.Device_SerialNumber}</td>
          {event.checkRemotePermission(data)}
          <td onClick={() => this.handleViewDevice(data.Device_UID)}><a className='device-view-link'>{t[language].settingsStoresViewDetails}</a></td>
        </tr>
      )
    })
    return rows
  }
  // Main render function. and get the Zoom devices value
  render () {
    const { language } = this.state
    return (
      <div>
        <h4 className='header'>{t[language].settingsStoresRegisteredZOOM}</h4>
        <table className='device-list-table'>
          <tbody>
            {this.CommonStoreMethods.renderDeviceListHeaders()}
            {this.renderRows()}
          </tbody>
        </table>
        <div className={'remove-sys ' + (this.authService.isAdmin() ? 'show' : 'hide')}>
          <Unregistersystem
            userEmail={this.props.stores.storeDetails.User_EmailAddress}
            zoomSystem={this.props.stores.Device_Details}
            deviceID={this.commonFunctions.removeDuplicateDevices(this.state.deviceIDs)} // {this.removeDuplicate(this.state.deviceIDs)}
            display={this.state.disableRemove}
            deviceName={this.state.deviceName}
            deviceStoreUID={this.props.stores.storeDetails.Store_UID} />
        </div>
      </div>
    )
  }
}

// Setting the state from redux store.
function mapStateToProps (state) {
  return {
    stores: state.StorePopupDetails.storePopupDetails
  }
}

export default connect(mapStateToProps)(ZoomComponent)



// WEBPACK FOOTER //
// ./src/components/Stores/ZoomComponent.js